
export const ObjectId = (rnd = r16 => Math.floor(r16).toString(16)) =>
    rnd(Date.now()/1000) + ' '.repeat(16).replace(/./g, () => rnd(Math.random()*16));

export const isRTL = str => {
    return /[\u0591-\u07FF]/.test(str);
};

    